import { toArray, toId, toText } from './list';

// Criteria arrive as plain strings in task bodies, but older payloads and
// review findings use objects ({ text } / { description }).
function criterionText(item) {
    if (typeof item === 'string') return item;
    return toText(item?.text ?? item?.description ?? item?.criterion, '');
}

function normalizeCommit(commit) {
    if (typeof commit === 'string') return { hash: commit, message: '', at: null };
    return { hash: toText(commit?.hash), message: toText(commit?.message), at: commit?.at ?? commit?.committed_at ?? null };
}

export function normalizeTask(raw) {
    const lastReturn = raw?.last_return;
    return {
        id: toId(raw?.id),
        title: toText(raw?.title, 'Sin título'),
        description: toText(raw?.description),
        kind: raw?.kind ?? null,
        estimate: raw?.estimate ?? null,
        priority: Number.isFinite(raw?.priority) ? raw.priority : null,
        state: raw?.workflow_state ?? raw?.state ?? null,
        modality: raw?.modality ?? null,
        assignee: raw?.assigned_to ? toText(raw.assigned_to.name ?? raw.assigned_to.display ?? raw.assigned_to) : null,
        projectId: toId(raw?.project_id ?? raw?.project),
        tierId: toId(raw?.tier_id ?? raw?.tier),
        tierName: raw?.tier?.name ?? null,
        repositoryId: toId(raw?.repository_id ?? raw?.repository),
        repositoryName: raw?.repository?.name ?? null,
        criteria: toArray(raw?.acceptance_criteria).map(criterionText).filter(Boolean),
        scope: toArray(raw?.scope).map((item) => toText(item)).filter(Boolean),
        commits: toArray(raw?.commits).map(normalizeCommit),
        originTaskId: toId(raw?.origin_task_id),
        blockedReason: raw?.blocked_reason ?? null,
        lastReturn: lastReturn ? { reason: toText(lastReturn.reason), at: lastReturn.at ?? null } : null,
        claimedBy: raw?.claimed ?? null,
        specRevision: raw?.spec_revision ?? null,
        createdAt: raw?.created_at ?? null,
        updatedAt: raw?.updated_at ?? null,
    };
}
